var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearnMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.70806L17.9873 17.2407C17.9868 17.6557 17.6315 17.9933 17.1953 17.9933H8.79972L8.80145 18H8.15255C7.75585 17.9999 7.36526 17.9449 7.02758 17.7358C6.46807 17.3895 6.11568 16.9043 6.03239 16.2636C6.00844 16.0795 6.00171 15.9882 6.00155 15.8024C5.99967 13.2588 5.99936 10.7151 6.00139 8.1714C6.00171 7.82021 6.05807 7.48094 6.21133 7.15283C6.36099 6.83232 6.59503 6.59402 6.87792 6.38164C7.25098 6.10149 7.67836 6.00021 8.14127 6.00006C10.3255 5.99947 14.4335 6.00319 15.7209 6.00617C15.9396 6.00662 16.1164 6.17536 16.1164 6.38343V13.6785C16.1164 13.8871 15.9387 14.0563 15.7194 14.0563C14.483 14.0565 10.6724 14.0566 8.65836 14.0557C6.61695 14.0557 6.60004 17.2471 8.6139 17.2471L8.61421 17.2482H17.1955C17.2007 17.2482 17.2047 17.2443 17.2047 17.2394L17.2174 7.70672C17.2177 7.50119 17.3929 7.33483 17.6088 7.33483H17.6093C17.8253 7.33543 18.0003 7.50238 18 7.70806ZM15.6377 15.1735H9.00183C8.78563 15.1735 8.61045 15.3401 8.61045 15.5458C8.61045 15.7515 8.78563 15.9182 9.00183 15.9182H15.6377C15.8539 15.9182 16.029 15.7515 16.029 15.5458C16.029 15.3401 15.8537 15.1735 15.6377 15.1735Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnMore);
export default __webpack_public_path__ + "static/media/learnMore.db103b3902407e868d8108cd49162b19.svg";
export { ForwardRef as ReactComponent };